module.exports = __webpack_public_path__ + "img/agustina-rabanal-byn.0d170d00.jpg";